<template>
  <div id="Kaleidoscope"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue";
import colorTool from "@/utils/colorTool";
const {changeToRgb, rgbToHsb} = colorTool()


const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['currentValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let animateSpeed = ref(2)
let high = ref(null)
let low = ref(null)
let nowTemperature = ref(null)
let backgroundColor = ref('rgb(0,0,0)')
let drawPot = ref(0)
let colorLow = ref([])
let colorHigh = ref([])
let currentColorArr = reactive({arr: []})



const handleGetAnimateHSBAndSpeed = (high, low, now = 10, colorHigh, colorLow) => {

  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 9) // 將高低差 分為 10個單位, 1單位


  let lowHeightColorRange

  let range = Math.trunc((now - low) / lowHeightRange)

  // 設定速度
  if (range <= 3) {
    animateSpeed.value = 2
    lowHeightColorRange = 1
  }
  else if (range >= 7 ) {
    animateSpeed.value = 6
    lowHeightColorRange = 10
  }
  else {
    animateSpeed.value = 4
    lowHeightColorRange = range
  }


  if (lowHeightColorRange === 1 ) currentColorArr.arr = colorLow.map(color => rgbToHsb(color))
  else if (lowHeightColorRange >= 10) currentColorArr.arr = colorHigh.map(color => rgbToHsb(color))
  else {
    const colorHighOne = rgbToHsb(colorHigh[0])

    const colorLowOne = rgbToHsb(colorLow[0])


    const nowColorOne = [
      (lowHeightColorRange * colorHighOne[0] + (10 - lowHeightColorRange) * colorLowOne[0]) / 10,
      (lowHeightColorRange * colorHighOne[1] + (10 - lowHeightColorRange) * colorLowOne[1]) / 10,
      (lowHeightColorRange * colorHighOne[2] + (10 - lowHeightColorRange) * colorLowOne[2]) / 10,
    ]
    currentColorArr.arr = [
      nowColorOne
    ]

    if (
        colorHighOne[0] === colorLowOne[0] &&
        colorHighOne[1] === colorLowOne[1] &&
        colorHighOne[2] === colorLowOne[2]
    ) {
      currentColorArr.arr[0] = colorHighOne
    }
  }
}


const kaleidoscopeAnimate = (sketch) => {
	let cw = defaultWidth.value
	let ch = defaultHeight.value

  let SIZE;
  let angle;
  let hyp;
  let phi = (1+sketch.sqrt(5))/9;
  let modifier = 0.065;
  let MOD_NUM = 5;
  let XSpeed = 11
	sketch.setup = () => {
    sketch.createCanvas(cw, ch)//
    sketch.colorMode(sketch.HSB, 360, 100,100, 255);
    sketch.smooth();
    sketch.background(0);
    sketch.noStroke();
    sketch.fill(0);
    modifier = 0.065;
    angle = 0;
    hyp = 10;
	}

	sketch.draw = () => {
    drawPot.value ++
    // init modifier
    if (modifier > 0.8) modifier = 0.065
    modifier += 0.00001/phi;
    // modifier += sketch.map(sketch.height, 0, sketch.height, -0.00001*animateSpeed.value*1.2, 0.00001*animateSpeed.value*1.2);
    let YSpeed = sketch.abs((sketch.height/2) + animateSpeed.value)
    modifier += sketch.map(YSpeed, 0, sketch.height, -0.0001*XSpeed, 0.0001*XSpeed);
    sketch.fill(0, 12);
    sketch.rect(0, 0, sketch.width*2, sketch.height*2);
    // console.log(modifier);

    angle = 0;
    hyp = 10;
    drawSpiral(currentColorArr.arr);
	}

  function drawSpiral(color) {

    // const ALPHA = 170 * sketch.abs(sketch.noise(angle)*100);
    const ALPHA = 180
    for (let i=0; i<1500; i++) {
      if (i % MOD_NUM == 0) sketch.fill(0,0,0, ALPHA);
      else sketch.fill(...color[0], ALPHA);
      let x = hyp * sketch.sin(angle) / sketch.noise(modifier/angle);
      let y = hyp * sketch.cos(angle) / sketch.noise(modifier/angle);
      SIZE = angle/30;
      angle += phi + modifier;
      if (angle >= 360) angle = 0;
      else hyp += 0.2 - modifier/2;
      sketch.push();
      sketch.translate(sketch.width/2, sketch.height/2);
      sketch.rectMode(sketch.CENTER);
      sketch.ellipse(x, y, SIZE, SIZE);
      sketch.pop()
    }
  }

}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

// watch(drawPot, (n, o) => {
//   if (n > 7200) { // 2min init
//     initAnimate()
//     canvasWrap.value = new p5(kaleidoscopeAnimate, 'Kaleidoscope')
//     drawPot.value = 0
//   }
// })

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value =  new p5(kaleidoscopeAnimate, 'Kaleidoscope')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
    Colors,
    HighColors,
    LowColors
  } = effectThemeData


  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  backgroundColor.value = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  if (IsDynamicMode.toString() === 'false') {
    currentColorArr.arr = Colors.map(color => rgbToHsb(color))
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    colorHigh.value = HighColors
    colorLow.value = LowColors
    handleGetAnimateHSBAndSpeed(high.value, low.value, nowTemperature.value, colorHigh.value, colorLow.value)
  }

})

onMounted(() => {
  // create p5
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(kaleidoscopeAnimate, 'Kaleidoscope')
})


onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  backgroundColor.value = 'rgb(0,0,0)'
  high.value = null
  low.value = null
  animateSpeed.value = 2
  currentColorArr.arr = []
  high.value = null
  low.value = null
  colorHigh.value = []
  colorLow.value = []
  initAnimate()
})

</script>
